const url = window.location.href;

const config = {
    isProductionEnv: url.includes('localhost') ? false : true,
    backendBaseUrl: url.includes('localhost')
        ? 'http://localhost:60003/'
        : url.includes('excelenciahml')
            ? 'https://excelenciaapihml.lojasmm.com.br/'
            : 'https://excelenciaapi.lojasmm.com.br/'
}

export default config;
